import './MortgageDiscountConditions.css';

import React, { useMemo } from 'react';
import { Checkbox, Collapse, Typography } from '@vtblife/uikit';

import classname from '@search/classname/src';
import { DiscountCalcEnum } from '@search/graphql-typings';
import { maxMortgageDiscountFormatted } from '../useChangeDiscount';

const cn = classname.bind(null, 'MortgageDiscountConditions');

const MortgageCondition = ({
    children,
    isMobile = false,
    disabled = false,
    value,
    onChangeDiscount,
    discountType
}: {
    value: boolean;
    children: string;
    isMobile?: boolean;
    disabled?: boolean;
    discountType: DiscountCalcEnum;
    onChangeDiscount: (checked: boolean, discountType: DiscountCalcEnum) => void;
}) => {
    const textStyleCheckbox = useMemo(() => {
        return isMobile ? 'small-alone' : 'secondary-alone';
    }, [ isMobile ]);

    return (
        <div className={cn('checkbox')}>
            <Checkbox disabled={disabled} value={value} onChange={checked => onChangeDiscount(checked, discountType)}>
                <Typography variant={textStyleCheckbox} color='black-500'>{children}</Typography>
            </Checkbox>
            <Typography variant={textStyleCheckbox}>-0,3%</Typography>
        </div>
    );
};

export const MortgageDiscountConditions = (
    {
        discountTypes,
        isMobile,
        discount,
        onChangeDiscount,
        className
    }: {
        discountTypes: readonly DiscountCalcEnum[];
        isMobile?: boolean;
        discount: string;
        className?: string;
        onChangeDiscount: (value: boolean, discountType: DiscountCalcEnum) => void;
    }
) => {
    return (
        <div className={cn(null, undefined, className)}>
            <Collapse size='s' variant='gray'>
                <Collapse.Item
                    title={`Как сэкономить ${maxMortgageDiscountFormatted}% на\u00A0ставке по\u00A0ипотеке от\u00A0ВТБ?`}
                >
                    {
                        <div className={cn('checkbox-group')}>
                            <MortgageCondition
                                discountType={DiscountCalcEnum.SbrElreg}
                                isMobile={isMobile}
                                value={discountTypes.includes(DiscountCalcEnum.SbrElreg)}
                                onChangeDiscount={onChangeDiscount}
                            >
                                Использование сервиса безопасных расчетов и&nbsp;электронной регистрации
                            </MortgageCondition>
                            <MortgageCondition
                                discountType={DiscountCalcEnum.SalaryProject}
                                value={discountTypes.includes(DiscountCalcEnum.SalaryProject)}
                                isMobile={isMobile}
                                onChangeDiscount={onChangeDiscount}
                            >
                                Являюсь участником зарплатного проекта ВТБ или готов им&nbsp;стать
                            </MortgageCondition>
                        </div>
                    }
                    {Number(discount) > 0 ? (
                        <div className={cn('final-value')}>
                            <Typography variant='secondary-alone' bold>
                                Скидка на&nbsp;ставку по&nbsp;ипотеке от&nbsp;банка ВТБ
                            </Typography>
                            <Typography variant='secondary-alone' bold>
                                {`-${discount.replace('.', ',')}%`}
                            </Typography>
                        </div>
                    ) : null}
                </Collapse.Item>
            </Collapse>
        </div>
    );
};
